/* Jutsumist: block checkout unless the cart holds at least one Jutsumist statue (add-ons alone cannot be ordered). */
(function () {
  var MAIN_PRODUCT_ID = 15411133808798;
  var MSG = 'Add a Jutsumist to your cart to check out. Add-ons ship with a statue only.';
  var EXPRESS = '.additional-checkout-buttons, shopify-accelerated-checkout-cart, shopify-accelerated-checkout, .dynamic-checkout__content, [data-shopify="dynamic-checkout-cart"]';
  var style = document.createElement('style');
  style.textContent = 'body.jm-no-main ' + EXPRESS.split(', ').join(', body.jm-no-main ') + '{display:none !important}';
  document.head.appendChild(style);
  function hasMain(cart) { return (cart.items || []).some(function (i) { return i.product_id === MAIN_PRODUCT_ID; }); }
  function sync(cart) {
    var ok = hasMain(cart);
    document.body.classList.toggle('jm-no-main', !ok);
    if (ok) { var box = document.getElementById('jm-min-order'); if (box) box.remove(); }
    return ok;
  }
  function check() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(sync); }
  function isCheckout(el) {
    return !!(el && el.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button'));
  }
  function warn(target) {
    var btn = target.closest('a, button, input') || target;
    var box = document.getElementById('jm-min-order');
    if (!box) {
      box = document.createElement('div'); box.id = 'jm-min-order';
      box.style.cssText = 'box-sizing:border-box;width:100%;flex:0 0 100%;margin:0 0 10px;padding:10px 12px;border:1px solid #E0141C;border-radius:8px;background:#2A0B0E;color:#F2F0EE;font-size:14px;line-height:1.4;text-align:center';
    }
    box.textContent = MSG;
    btn.parentNode.insertBefore(box, btn);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!isCheckout(t)) return;
    var b = t.closest('a, button, input');
    if (b.dataset.jmOk === '1') return;
    e.preventDefault(); e.stopImmediatePropagation();
    check().then(function (ok) {
      if (ok) { b.dataset.jmOk = '1'; b.click(); setTimeout(function () { b.dataset.jmOk = ''; }, 1500); }
      else warn(b);
    });
  }, true);
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var p = _fetch.apply(this, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(check, 300); });
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
